import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService, UIService } from 'src/app/_services';
import { UserService } from 'src/app/_services/user.service';

/** Read-only user page; the user comes from the list row, or is loaded by id after a reload */
@Component({
    selector: 'app-user-view',
    templateUrl: './user-view.component.html',
    styleUrls: ['../partners/view/partner-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserViewComponent implements OnInit {
  user: any;
  details: [string, string][] = [];

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private UIService: UIService,
    public auth: AuthService,
  ) { }

  ngOnInit() {
    this.UIService.setTitle('View User');
    this.setUser(history.state?.data?.user);
    if (this.user) { return; }

    // if the load fails the page points back to the user list
    this.userService.getUser(this.route.snapshot.paramMap.get('id')).subscribe({
      next: ({ user }) => this.setUser(user),
      error: () => {},
    });
  }

  private setUser(user: any) {
    this.user = user;
    if (!user) { return; }

    this.details = ([
      ['User UUID', user.id],
      ['Email', user.email],
      ['Phone', user.phone],
      ['Role', user.role],
      ['Partner', this.auth.hasAccess('SuperAdmin') && user.partner?.name],
    ] as [string, string][]).filter(([, value]) => value);
  }
}
